var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.stateInfo)?_c('v-chip',{attrs:{"small":!_vm.xSmall,"x-small":_vm.xSmall,"color":_vm.stateInfo.color,"dark":""}},[_vm._v(" "+_vm._s(_vm.stateInfo.label)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }